import React from 'react'
import Branding from './Branding'
import PageSection from './PageSection'
import Compliance from './Compliance'
import Booking from './Booking'
import Footer from './Footer'
import Clients from './Clients'

import { SiGoogleads } from "react-icons/si";
import { FaAd, FaBullhorn, FaGlobe, FaShareAlt, FaClock } from "react-icons/fa";
import { useNavigate } from 'react-router-dom'

import fs from '../../AdImage/adoverview.png';
import ads from '../../AdImage/adscheduling.jpeg';

import psa from '../../AdImage/personalizedAds.png';

import mc from '../../AdImage/multichannel.jpeg';
import lc from '../../AdImage/localiza.png';



function Ads() {
  const navigate = useNavigate();


  const personalizedAdsData = [
    {
      icon: <FaBullhorn />,
      iconTitle: 'Personalized Ads',
      image: psa,
      title: 'Create targeted and personalized ads to enhance customer engagement and conversion.',
      lines: [
        'Tailor ad content based on individual customer preferences.',
        'Implement personalized offers and promotions for increased conversions.',
        'Optimize ad campaigns for relevance and effectiveness.'
      ],
    },
  ];
  const localizationData = [
    {
      icon: <FaGlobe />,
      iconTitle: 'Localization',
      image: lc,
      title: 'Localize ads to cater to diverse audiences and maximize global reach.',
      lines: [
        'Translate ad content for different languages and regions.',
        'Adapt campaigns to local cultural nuances for better resonance.',
        'Enhance brand visibility and connect with customers on a global scale.'
      ],
    },
  ];
  
  const multichannelPublicationData = [
    {
      icon: <FaShareAlt />,
      iconTitle: 'Multichannel Publication',
      image: mc,

      title: 'Publish ads across multiple channels for extensive reach and engagement.',
      lines: [
        'Distribute ads on various platforms and social media channels.',
        'Optimize content for each channel to maximize effectiveness.',
        'Enhance brand visibility through a strategic multichannel approach.'
      ],
    },
  ];
  
  const schedulingData = [
    {
      icon: <FaClock />,
      iconTitle: 'Scheduling',
      image: ads,
      title: 'Strategically schedule ad campaigns to reach the right audience at the right time.',
      lines: [
        'Plan and schedule ads for optimal visibility and engagement.',
        'Align campaigns with peak times and relevant events.',
        'Enhance ad performance with strategic scheduling.'
      ],
    },
  ];
  
  
  return (
    <div className='pt-5  gap-[70px] flex flex-col items-center min-h-full w-full'>
    <div className='w-full flex justify-center bg-white sticky top-0 pt-5'>
        <div   className={` w-[78%]   flex  bg-white  pb-4 `}>    
            <div className='flex gap-2 items-center'>
                <div>
                <SiGoogleads className='text-[30px] text-blue-600' />
                </div>
                <div className='flex flex-col'>
                    <span className='semibold text-[13px]'>Elyzian</span>
                    <span className='bold text-sm'>Ad Management</span>

                </div>
            </div>
        </div>
  </div>

  {/* 1st Section */}

  <div   className="w-full sm:w-[90%] lg:w-[85%] 2xl:w-[78%] h-max lg:h-[620px] sm:mt-3  flex flex-col lg:flex-row gap-6 lg:gap-3   p-[5%] bg-[#fafafa] sm:rounded-[50px]">       
     <div className='w-full lg:w-[50%] flex flex-col gap-5 justify-start h-full'>
        <div>     
        <span className='bold text-[28px] lg:text-[32px] xl:text-[38px] 2xl:text-[44px]   sm:leading-[45px] xl:leading-[55px] 2xl:leading-[65px]'>Elevate Engagement,<br /> Maximize Impact.</span>    
</div>
       
        <span className='regular  text-sm sm:text-base lg:text-[18px] 2xl:text-[20px] leading-[26px] lg:leading-[36px]  '>Optimize your ad campaigns with Ads Personalization, delivering targeted content and strategic scheduling for unparalleled customer engagement.Elevate your advertising game with Ads Personalization.
        </span>
        
            
            <button onClick={() => navigate('/waitlist')} className="flex items-center gap-2 text-sm w-max  sm:text-[14px]  tracking-wide rounded-lg hover:shadow hover:bg-[#1e46f6f6] hover:ring-[2px] hover:ring-blue-200 bold px-3 py-2 sm:px-5 border sm:p-[12px] bg-[#1e47f6] border-[#1e47f6] text-white hover:transition hover:delay-200">
<span className="button-content medium">Get Started Free</span>
</button>
     </div>
     <div className=' w-full lg:w-[50%]'>
     <img className='rounded-2xl aspect-auto' src={fs} alt="" />
     </div>
  </div>

  {/* 2nd Section */}
        <Clients />

        {/* 3rd Section */}
    
  {/* 4th Section */}
  <PageSection bg  data={personalizedAdsData} />

  <PageSection reverse  data={localizationData} />
  {/* <Clients /> */}


  <PageSection   data={multichannelPublicationData} />


  <PageSection reverse  data={schedulingData}  />

  <Branding />





  <Compliance />

  <Booking />

  <Footer />






</div>
  )
}

export default Ads
